{
  "version": 1,
  "asset_id": "ec7ab406-2b51-4b4b-bfe1-f48a6153007c",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/ec7ab406-2b51-4b4b-bfe1-f48a6153007c/author-dirk-van-haaster.webp",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/ec7ab406-2b51-4b4b-bfe1-f48a6153007c/author-dirk-van-haaster.webp",
  "original_filename": "author-dirk-van-haaster.webp",
  "size": 6498,
  "content_type": "image/webp",
  "created_at": "2026-08-30T14:14:41Z"
}
